// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "modal__root-1Ux_-";
var _3 = "title-2iFJF";
var _4 = "content-3pVzT";
var _5 = "seats__info-29D9L";
var _6 = "seats-2_WzC";
var _7 = "seats_items-1b1A9";
var _8 = "seat-T1PT9";
var _9 = "economy-rKsQd";
var _a = "preferred-3zNox";
var _b = "business-735Aq";
var _c = "free-30F8F";
var _d = "extendedIcon-1DNUM";
var _e = "icon-3jMHT";
var _f = "name-22Atf";
var _10 = "info-19lIk";
var _11 = "price__details_wrapper-1LPDT";
var _12 = "price__details_item-3WXd7";
var _13 = "price__details_price-1v_wG";
var _14 = "price__total_wrapper-2xqgf";
var _15 = "price__total_price-3OCcZ";
var _16 = "line__horizontal-3nb8n";
var _17 = "line__vertical-3mtxp";
var _18 = "description-oWjWy";
var _19 = "parameters-1TEV1";
var _1a = "button-ioEPB";
var _1b = "additionalInfo-FNPQv";
var _1c = "additionalInfo__title-oXfQM";
export { _1 as "__esModule", _2 as "modal__root", _3 as "title", _4 as "content", _5 as "seats__info", _6 as "seats", _7 as "seats_items", _8 as "seat", _9 as "economy", _a as "preferred", _b as "business", _c as "free", _d as "extendedIcon", _e as "icon", _f as "name", _10 as "info", _11 as "price__details_wrapper", _12 as "price__details_item", _13 as "price__details_price", _14 as "price__total_wrapper", _15 as "price__total_price", _16 as "line__horizontal", _17 as "line__vertical", _18 as "description", _19 as "parameters", _1a as "button", _1b as "additionalInfo", _1c as "additionalInfo__title" }
export default { "__esModule": _1, "modal__root": _2, "title": _3, "content": _4, "seats__info": _5, "seats": _6, "seats_items": _7, "seat": _8, "economy": _9, "preferred": _a, "business": _b, "free": _c, "extendedIcon": _d, "icon": _e, "name": _f, "info": _10, "price__details_wrapper": _11, "price__details_item": _12, "price__details_price": _13, "price__total_wrapper": _14, "price__total_price": _15, "line__horizontal": _16, "line__vertical": _17, "description": _18, "parameters": _19, "button": _1a, "additionalInfo": _1b, "additionalInfo__title": _1c }
